import { Callout, Button, Flex } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { useIntl } from "react-intl";
import { useSpaNavigate } from "shared-ui";

import { COMMON_MESSAGES } from "../../../components/common-messages";
import { NAVIGATION_PATHS } from "../../../components/constants";
import { MESSAGES } from "../message-definitions";

import { AIRList } from "./air-list/air-list";

interface ReviewAirsProps {
  airsData: FundingApplicationSchemas.AdditionalInformationRequestsData;
}

export const ReviewApplicationProgress = ({ airsData }: ReviewAirsProps) => {
  const intl = useIntl();
  const { navigate } = useSpaNavigate("FundingApp");

  if (!airsData.airs.length) {
    // No AIRs, navigate back to in review screen
    navigate(NAVIGATION_PATHS.IN_REVIEW);
  }

  return (
    <Flex direction="column" gap="8">
      {airsData.hasActiveAirs ? (
        <Callout
          variant="warning"
          title={intl.formatMessage(MESSAGES.airReviewPageOnHoldBannerTitle)}
          description={intl.formatMessage(MESSAGES.airReviewPageOnHoldBannerSubheading)}
        />
      ) : null}
      <AIRList airs={airsData.airs} airPath={NAVIGATION_PATHS.ADDITIONAL_INFORMATION_REQUEST} />
      <Flex>
        <Button variant="Ghost" onClick={() => navigate(NAVIGATION_PATHS.IN_REVIEW)}>
          {intl.formatMessage(COMMON_MESSAGES.backLabel)}
        </Button>
      </Flex>
    </Flex>
  );
};
